import styled from 'styled-components';

// The base shell layout used for the pages.
// Example Usage
// <PageShellLayout> <PageShell> <COMPONENT /> </PageShell></PageShellLayout>
// Here the COMPONENT will be aligned with the base structure.
export const PageShellLayout = styled.div`
  display: flex;
  justify-content: center;
`;

//This is the base shell containing the page
export const PageShell = styled.div`
  width: 50vw;
  min-width: 40rem;
  align: center;
  margin-top: 1em;
  margin-bottom: 1em;
`;
